<div class="keno-grid-container firm-sub-account-users-grid-host">
  <particle-virtual-grid
    *ngIf="gridHostReady"
    [sourceKey]="sourceKey"
    [sortFieldKey]="sortFieldKey"
    [sortDirection]="sortDirection"
    [invalidateSubject]="invalidateSubject"
    [parameters]="gridParameters"
    [api]="api"
    [serviceName]="serviceName"
    (valueChanged)="onValueChange($event)"
    version="v2"
    tabStyle="compact"
    [magicLinkModel]="magicLinkModel"
  ></particle-virtual-grid>
</div>
